<template>
	<div class="card mb-4">
		<div class="card-header bg-info text-light">
			My Account
		</div>
		<div class="card-body">
			<ul class="list-group">
				<router-link class="list-group-item" tag="li" to="/account">
					<a>My Profile</a>
					<p>Manage your user profile</p>
				</router-link>
				<router-link class="list-group-item" tag="li" v-if="isorgadmin" to="/organization">
					<a>Organization Admin</a>
					<p>Manage your organization.  Edit your organization's information, add and remove users, and more.</p>
				</router-link>
			</ul>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserAccountPanel',
  computed: {
    ...mapGetters('auth', ['isloggedin', 'isorgadmin'])
  },
  methods: {
    ...mapActions('auth', ['logout'])
  }
}

</script>
